import React from 'react'
//import { useSelector } from 'react-redux'

import ContactEmailBody from '../Components/ContactEmailBody/ContactEmailBody'
import Footer from '../Components/Footer/Footer'
//import ChatBot from '../Components/Chat/ChatBot'
//import Chat from '../Components/Chat/Chat'
//import WhatsAppOrEmail from '../Components/WhatsAppOrEmail/WhatsAppOrEmail';

function Contact() {
    
    //const state = useSelector(state => state.email.email);
    

    return (
    <>
      
  
      <ContactEmailBody/> 
   
      <Footer></Footer>
      
      {/* <Chat/> */}
      {/* <ChatBot/> */}
  
    
    </>    
    ) 
}

export default Contact
